import React from 'react';

import MainScreen from './MainScreen';

const App: React.FC = () => {
  return <MainScreen />;
};

export default App;
